<template>
  <ion-page class="review">
    <img class="review_mask" src="@/assets/teacher_index/version5/test_mask.png" alt="" />
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div class="nav-icon"></div>
        <span>复习</span>
        <div style="display: inline-flex; align-items: center">
          <switch-font-size />
          <img
            class="nav-icon"
            :src="getBrandImageUrl('close_icon.png')"
            alt=""
            @click="onCloseModel"
          />
        </div>
      </div>
    </ion-header>
    <div class="word-box">
      <VideoHeight />
      <div id="review_outside_id" class="review_outside">
        <div class="statistic">{{ dataList.length }}个单词</div>
        <div
          id="scroll-wrap-review"
          class="review_page"
          :class="{ 'scroll-disabled': !canScroll() }"
          @scroll="ionScroll($event)"
          @wheel="preventScroll"
          @touchmove="preventScroll"
        >
          <div class="word-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row justify-between align-center cursor-pointer"
              :class="{ 'choose-true': item.selected === 2, 'choose-false': item.selected === 1 }"
              @click="onShowParaphrase(index, item, $event)"
            >
              <div class="flex-row flex-wrap" style="width: calc(100% - 30%)">
                <span class="word-style flex-row align-center">
                  <span class="word-style gray-color" style="flex-shrink: 0; font-size: 14px">
                    {{ index + 1 }}.
                  </span>
                  <span class="weight-600 switch-font-size-video">{{ item.word }}</span>
                </span>
                <span
                  v-show="item.showParaphrase == 2"
                  class="cnword word-style gray-color translate-middle"
                  >{{ item.paraphrase }}</span
                >
              </div>

              <div class="choose-icon flex-row align-center">
                <img
                  v-if="item.selected === 0 || item.selected === 2"
                  class="test-icon"
                  src="@/assets/teacher_index/version5/word_false.svg"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 1"
                  class="test-icon"
                  src="@/assets/teacher_index/version5/checked_word_false.svg"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 0 || item.selected === 1"
                  class="test-icon ml-3"
                  src="@/assets/teacher_index/version5/word_ok.svg"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  v-if="item.selected === 2"
                  class="test-icon ml-3"
                  src="@/assets/teacher_index/version5/checked_word_true.svg"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/not_play_icon.png')"
                  alt=""
                />
                <img
                  v-if="false"
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/playing_icon.png')"
                  alt=""
                />
              </div>
            </div>
            <ion-content>
              <ion-infinite-scroll
                id="infinite-scroll"
                threshold="100px"
                :disabled="isDisabled"
                @ionInfinite="loadData($event)"
              >
                <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
            </ion-content>
            <ion-content>
              <ion-infinite-scroll
                id="infinite-scroll"
                threshold="100px"
                :disabled="isDisabled"
                @ionInfinite="loadData($event)"
              >
                <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
            </ion-content>
          </div>
        </div>
      </div>
    </div>

    <!--    <page-white-background title="复习" router-type="modal" @router-back="onCloseSelf">
      <template #default>
        <div class="review_page">
          <div class="statistic mb-5">{{ dataList.length }}个单词</div>
          <div class="word-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row justify-between"
              @click="onShowParaphrase(index, item, $event)"
            >
              <span class="word-style flex-row align-center">
                <span class="word-style gray-color">{{ index + 1 }}.</span>{{ item.word }}
              </span>
              <span
                v-show="item.showParaphrase == 2"
                class="cnword word-style gray-color translate-middle"
                >{{ item.paraphrase }}</span
              >
              <div class="flex-row align-center">
                <img
                  v-if="item.selected === 0 || item.selected === 2"
                  class="test-icon"
                  :src="getBrandImageUrl('speed/not_check_icon.png')"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 1"
                  class="test-icon"
                  :src="getBrandImageUrl('speed/checked_icon.png')"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 0 || item.selected === 1"
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/not_know_icon.png')"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  v-if="item.selected === 2"
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/checked_not_know_icon.png')"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/not_play_icon.png')"
                  alt=""
                />
                <img
                  v-if="false"
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/playing_icon.png')"
                  alt=""
                />
              </div>
            </div>
            <ion-content>
              <ion-infinite-scroll
                id="infinite-scroll"
                threshold="100px"
                :disabled="isDisabled"
                @ionInfinite="loadData($event)"
              >
                <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
            </ion-content>
          </div>
        </div>
      </template>
</page-white-background>-->
    <div class="review_bottom">
      <div class="review_bottom-content flex-row justify-between align-center">
        <div>
          <span
            >正确<span class="common-color">{{ yesNum }}</span></span
          >
          <span class="display-inline-block ml-1"
            >错误<span class="common-red-color">{{ notNum }}</span></span
          >
        </div>
        <div>
          <ion-button v-if="dataList.length" class="button-outline" shape="round" @click="autoPlay"
            >{{ autoPlayButtonText }}
          </ion-button>
          <ion-button class="golden_bg" shape="round" @click="doCheckAll">全选</ion-button>
          <ion-button class="green_bg" shape="round" @click="doSubmit">提交</ion-button>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import {
  IonButton,
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonPage,
  modalController,
} from "@ionic/vue"
import mqttServer from "@/js/mqtt"
import { checkmarkCircle, closeCircle, library } from "ionicons/icons"
import { getBrandImageUrl } from "@/js/brandImages"
import checkOkWord from "@/assets/teacher_index/version5/checked_word_false.svg"
import checkFalseWord from "@/assets/teacher_index/version5/checked_word_true.svg"
import pagesQueue from "@/js/pagesQueue"
import { openMsgToast } from "@/js/message"
import { debounce } from "lodash"
import VideoHeight from "@/views/liveVideo/components/videoHeight.vue"
import { useStorage } from "@vueuse/core"
import SwitchFontSize from "@/views/liveVideo/components/switchFontSize.vue"

export default {
  name: "SpeedReview",
  components: {
    IonHeader,
    IonInfiniteScrollContent,
    IonInfiniteScroll,
    IonPage,
    IonContent,
    IonButton,
    VideoHeight,
    SwitchFontSize,
  },
  props: ["studentId", "mastery"],

  setup() {
    // 获取会话存储中学生和老师单词列表高度
    const studentOffsetHeight = useStorage("studentOffsetHeight", "", sessionStorage)
    const teacherOffsetHeight = useStorage("teacherOffsetHeight", "", sessionStorage)
    // 获取会话存储中学生和老师单词列表宽度
    const studentOffsetWidth = useStorage("studentOffsetWidth", "", sessionStorage)
    const teacherOffsetWidth = useStorage("teacherOffsetWidth", "", sessionStorage)
    return {
      closeCircle,
      checkmarkCircle,
      library,
      studentOffsetHeight,
      teacherOffsetHeight,
      studentOffsetWidth,
      teacherOffsetWidth,
    }
  },

  data() {
    return {
      timer: null,
      debouncedScrollHandler: null, // 防抖滚动处理函数
      canScrollPermission: true, // 添加响应式的滚动权限状态
      instructData: {
        project: "lxll",
        page: "teachIndex",
        module: "Review",
        pageModle: true,

        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      isDisabled: false,
      dataList: [],
      selectYesIndex: [], // 巡查官使用该数组确保展示同步
      selectNotIndex: [], // 巡查官使用该数组确保展示同步
      yesNum: 0,
      notNum: 0,
      courseId: undefined,
      courseName: undefined,
      autoPlaySwitch: false,
      autoPlayTimer: undefined,
      autoTimePlayTimer: undefined,
      autoPlayIndex: 0,
      autoPlayButtonText: "播放",
    }
  },

  watch: {
    // 监听会话存储中老师通过即构通讯获取的学生单词列表高度，并设置老师单词列表高度
    studentOffsetHeight(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("review_outside_id")
      if (newVal > this.teacherOffsetHeight) {
        dom.style.height = this.teacherOffsetHeight + "px"
      } else {
        dom.style.height = newVal + "px"
      }
    },
    // 监听会话存储中学生通过即构通讯获取的老师单词列表高度，并设置学生单词列表高度
    teacherOffsetHeight(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("review_outside_id")
      if (newVal > this.studentOffsetHeight) {
        dom.style.height = this.studentOffsetHeight + "px"
      } else {
        dom.style.height = newVal + "px"
      }
    },
    //监听会话存储中学生通过即构通讯获取的老师单词列表宽度，并设置学生单词列表宽度
    teacherOffsetWidth(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("review_outside_id")
      if (newVal > this.studentOffsetWidth) {
        dom.style.width = this.studentOffsetWidth + "px"
      } else {
        dom.style.width = newVal + "px"
      }
    },
    //监听会话存储中老师通过即构通讯获取的学生单词列表宽度，并设置老师单词列表宽度
    studentOffsetWidth(newVal) {
      // 巡查官不执行后续代码
      if (this.userinfo.isAdmin) return
      let dom = document.getElementById("review_outside_id")
      if (newVal > this.teacherOffsetWidth) {
        dom.style.width = this.teacherOffsetWidth + "px"
      } else {
        dom.style.width = newVal + "px"
      }
    },
  },
  created() {
    // sessionStorage.setItem('pageFlag', 'false')
  },

  mounted() {
    sessionStorage.removeItem("isManual")

    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)
    this.userinfo = this.store.getUser()

    // 初始化滚动权限状态
    this.updateScrollPermission()

    // 添加权限变化监听器
    mqttServer.addPermissionListener(this.updateScrollPermission)

    // 初始化防抖滚动处理函数
    this.debouncedScrollHandler = debounce((e) => {
      // 只有有滚动权限的用户才能发送滚动消息
      if (this.canScroll()) {
        mqttServer.pushMsg(this.instructData, {
          params: [JSON.parse(JSON.stringify(e.target.scrollTop))],
          fn: "handleScroll",
          msgType: "function",
          udp: true,
        })
      }
    }, 500)

    this.handleAlert().then((value) => {
      setTimeout(() => {
        value.dismiss("NEXT", "", "PageDialog")
      }, 2000)
    })

    if (this.dataList.length == 0) {
      this.queryMyWords()
    } else {
      setTimeout(() => {
        sessionStorage.setItem("pageFlag", "true")
      })
    }

    // 巡查官不执行后续代码
    if (this.userinfo.isAdmin) return
    setTimeout(() => {
      // 等待1秒iframe浏览器渲染完成，获取单词列表高度，并抛出到父级窗口
      let dom = document.getElementById("review_outside_id")
      window.parent.postMessage(
        {
          offsetHeight: dom.offsetHeight,
          offsetWidth: dom.offsetWidth,
          userType: this.userinfo.userType,
        },
        "*"
      )
      // 设置会话存储中学生和老师单词列表高度
      if (this.userinfo.userType == 1) {
        this.studentOffsetHeight = dom.offsetHeight
        this.studentOffsetWidth = dom.offsetWidth
      } else {
        this.teacherOffsetHeight = dom.offsetHeight
        this.teacherOffsetWidth = dom.offsetWidth
      }
    }, 1000)
  },

  beforeUnmount() {
    // 清理防抖函数
    if (this.debouncedScrollHandler) {
      this.debouncedScrollHandler.cancel()
    }
    // 移除权限变化监听器
    mqttServer.removePermissionListener(this.updateScrollPermission)
  },

  methods: {
    // 检查当前用户是否有发送权限（即是否有滚动权限）
    canScroll() {
      const appointment = this.store.getAppointment()
      // 如果是巡查官，总是可以滚动,或者不是视频课，也能滚动
      if ((this.userinfo && this.userinfo.isAdmin) || appointment.videoFlag != 1) {
        return true
      }
      // 使用响应式的权限状态
      return this.canScrollPermission
    },

    // 更新滚动权限状态
    updateScrollPermission() {
      this.canScrollPermission = mqttServer.getCanSend()
    },

    // 关闭复习
    onCloseModel() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onCloseModelSync",
          msgType: "function",
        })
        .then(() => {
          this.onCloseModelSync()
        })
    },
    onCloseModelSync() {
      clearInterval(this.autoPlayTimer)
      clearTimeout(this.autoTimePlayTimer)
      pagesQueue.queuePagePop()
      modalController.dismiss()
    },

    // 处理消息
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },
    // 打开提示对话框
    async handleAlert() {
      return this.alert(
        true,
        false
      )
    },
    // 阻止滚动事件
    preventScroll(e) {
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },

    ionScroll(e) {
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
      if (this.debouncedScrollHandler) {
        this.debouncedScrollHandler(e)
      }
    },

    handleScroll(e) {
      const dom = document.getElementById("scroll-wrap-review")
      if (dom) {
        dom.scrollTop = e
      }
    },

    getBrandImageUrl,
    routerBack() {
      modalController.dismiss()
    },
    //学信异步
    async openSignSync() {
      sessionStorage.setItem("pageFlag", "false")

      pagesQueue.queuePagePush({
        page: "Sign",
        params: { studentId: this.studentId, step: 1 },
      })
      //
      // const modal = await modalController.create({
      //   component: Sign,
      //   componentProps: { studentId: this.studentId, step: 1 },
      //   cssClass: "modal_controller_class",
      // })
      // await modal.present()
      // const { data } = await modal.onDidDismiss()
      // if (data) {
      //   await modalController.dismiss({ ...data })

      // if (data.hasOwnProperty('courseTypeId') && data.courseTypeId===16) {
      // } else {
      //   await modalController.dismiss();
      // }
      // }
    },
    //学新
    async openSign() {
      // mqttServer
      //   .pushMsg(this.instructData, {
      //     fn: "openSignSync",
      //     msgType: "function",
      //   })
      //   .then(async () => {
      //   })
      this.openSignSync()
    },
    // 点击发音
    onShowParaphraseSync(index, item) {
      this.playSound(item.word)
      // for (let i = 0; i < this.dataList.length; i++) {
      //   if (index == i) {
      //     if (this.dataList[i].showParaphrase < 2) {
      //       this.dataList[i].showParaphrase++
      //     } else {
      //       this.dataList[i].showParaphrase = 0
      //     }
      //   } else {
      //     this.dataList[i].showParaphrase = 0
      //   }
      // }
    },

    //点击播放
    onShowParaphrase(index, item) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [index, item],
          fn: "onShowParaphraseSync",
          msgType: "function",
        })
        .then(() => {
          this.onShowParaphraseSync(index, item)
        })
    },

    //选中打对打错的数据
    countSelectNum() {
      this.yesNum = 0
      this.notNum = 0
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].selected == 1) {
          this.yesNum++
        } else if (this.dataList[i].selected == 2) {
          this.notNum++
        }
      }
    },

    //全选
    doCheckAllSync(selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          this.tools.onClickYes(this.dataList[selectYesIndex[i]])
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          this.tools.onClickNot(this.dataList[selectNotIndex[i]])
        }
        this.countSelectNum()
      }
      this.yesNum = 0
      this.notNum = 0
      const unSelectedArr = this.dataList.filter((i) => i["selected"] !== 2) // 所有未选中单词数组
      const unSelectedLen = unSelectedArr.length // 所有未选中单词数组长度
      this.notNum = this.dataList.length - unSelectedLen // 所有已选中单词数组长度
      for (let i = 0; i < unSelectedArr.length; i++) {
        const obj = unSelectedArr[i]
        if (this.notNum < 45) {
          // 当前未选中单词数组长度 < 45个单词内不认识的未选中单词
          if (obj["selected"] === 0) {
            this.notNum++
            this.tools.onClickNot(unSelectedArr[i])
          }
        } else {
          if (obj["selected"] !== 1) {
            // 如果选中效果为已学会，则不取消选中
            this.tools.onClickNull(unSelectedArr[i])
          }
        }
      }
      const arr = this.dataList.filter((i) => i["selected"] === 1)
      if (arr) {
        this.yesNum = arr.length
      }
    },

    //全选
    doCheckAll() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.selectYesIndex, this.selectNotIndex],
          fn: "doCheckAllSync",
          msgType: "function",
        })
        .then(() => {
          this.doCheckAllSync()
        })
    },

    //自动播放
    autoPlaySync() {
      clearInterval(this.autoPlayTimer)
      clearTimeout(this.autoTimePlayTimer)
      if (this.autoPlaySwitch) {
        this.autoPlaySwitch = false
        this.autoPlayButtonText = "播放"
      } else {
        this.autoPlaySwitch = true
        this.autoPlayButtonText = "停止"
        this.autoPlayIndex = this.autoPlayIndex >= this.dataList.length ? 0 : this.autoPlayIndex
        let word = this.dataList[this.autoPlayIndex++].word
        this.playSound(word)
        let that = this
        this.autoPlayTimer = setInterval(() => {
          word = that.dataList[that.autoPlayIndex++].word
          that.playSound(word)
        }, 2200)
        this.autoTimePlayTimer = setTimeout(
          () => {
            this.autoPlaySwitch = true
            this.autoPlay()
          },
          2200 * (that.dataList.length - that.autoPlayIndex + 0.8)
        )
      }
    },

    //自动播放
    autoPlay() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "autoPlaySync",
          msgType: "function",
        })
        .then(() => {
          this.autoPlaySync()
        })
    },

    doSubmit() {
      const appointment = this.store.getAppointment()
      //判断是视频课，且是发送方才能点击提交
      if (appointment != null) {
        if (appointment.videoFlag == 1 && !mqttServer.getCanSend()) {
          return
        }
      }

      const that = this
      this.countSelectNum()
      if (this.yesNum + this.notNum == 0) {
        openMsgToast("请选择单词")
        return
      }
      clearInterval(this.autoPlayTimer)
      clearTimeout(this.autoTimePlayTimer)

      const param = { studentId: this.studentId }

      let url = null
      //如果用户就是自己，则判断为陪练自己在体验教学流程
      if (this.studentId == this.userinfo.userId) {
        url = "/vocabulary/beginTrailClass"
      } else {
        url = "/vocabulary/beginReviewClass"
        const appointment = this.store.getAppointment()
        param.aptmId = appointment.aptmId
        param.courseId = appointment.courseId
        param.courseName = appointment.courseName
      }
      //如果是视频课，学生操作的时候就
      let isSend = mqttServer.getCanSend()
      if (isSend) {
        url = "/vocabulary/beginReviewClass"
        const appointment = this.store.getAppointment()
        param.aptmId = appointment.aptmId
        param.courseId = appointment.courseId
        param.courseName = appointment.courseName
      }

      const selectedItem1 = []
      const selectedItem2 = []

      if (this.dataList && this.dataList.length > 0) {
        // 打勾的单词mastery=8，打叉的mastery=1
        //此处找出所有被打了X标记的单词
        this.dataList.forEach((item) => {
          if (item.selected > 0) {
            let obj = {
              id: item.id,
              vocabularyId: item.vocabularyId,
              studentId: this.studentId,
              courseId: item.courseId,
              mastery: item.mastery,
              selected: item.selected,
              word: item.word,
              paraphrase: item.paraphrase,
              pronunciation: item.pronunciation,
            }

            //只要打了标记的单词，都提交到后台
            selectedItem1.push(obj)

            if (item.selected == 2) {
              selectedItem2.push(obj)
            }
          }
        })
      }

      //向后台提交所有做了标记的单词
      param.list = selectedItem1

      // this.ajax.post(url, param).then((res) => {
      //   if (res.data.success) {

      //本地只存打了叉，不会的单词

      this.handleResult(url, param, selectedItem2)
    },

    // 关闭模态弹框
    cancelModel() {
      pagesQueue.queuePagePop()
      modalController.dismiss({ status: "REVIEW" })
    },

    // 提交时接口调用
    async handleResult(url, param, selectedItem2, res, selectYesIndex, selectNotIndex) {
      clearInterval(this.autoPlayTimer)

      if (res) {
        if (this.userinfo.isAdmin) {
          for (let i = 0; i < selectYesIndex.length; i++) {
            if (this.dataList[selectYesIndex[i]].selected != 1) {
              this.tools.onClickYes(this.dataList[selectYesIndex[i]])
            }
          }
          for (let i = 0; i < selectNotIndex.length; i++) {
            if (this.dataList[selectNotIndex[i]].selected != 2) {
              this.tools.onClickNot(this.dataList[selectNotIndex[i]])
            }
          }
          this.countSelectNum()
        }
        if (this.notNum > 0) {
          if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
            this.openSign()
          } else {
            this.createForget()
          }
        } else {
          this.cancelModel()
        }
        //本地只存打了叉，不会的单词
      } else {
        this.ajax.post(url, param).then(async (res) => {
          if (res.data.success) {
            param.list = selectedItem2
            mqttServer.pushMsg(this.instructData, {
              params: [url, param, selectedItem2, res, this.selectYesIndex, this.selectNotIndex],
              fn: "handleResult",
              msgType: "function",
            })
            if (this.notNum > 0) {
              if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
                this.openSign()
              } else {
                this.createForget()
              }
            } else {
              this.cancelModel()
            }
          }
        })
      }
    },
    async createForget() {
      const appointment = this.store.getAppointment()
      const params = {
        aptmId: appointment.aptmId,
        startTime: appointment.beginTime,
      }
      return this.ajax.post("/forget/generateForget", params).then(() => {
        this.openSign()
      })
    },

    onClickYesSync(item, selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          if (this.dataList[selectYesIndex[i]].selected != 1) {
            this.tools.onClickYes(this.dataList[selectYesIndex[i]])
          }
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          if (this.dataList[selectNotIndex[i]].selected != 2) {
            this.tools.onClickNot(this.dataList[selectNotIndex[i]])
          }
        }
        // 合并selectYesIndex和selectNotIndex，在dataList中找到索引不等于合并后的索引的单词，把selected设置为0
        const allIndex = [...selectYesIndex, ...selectNotIndex]
        for (let i = 0; i < this.dataList.length; i++) {
          if (!allIndex.includes(i)) {
            this.dataList[i].selected = 0
          }
        }
        this.countSelectNum()
      } else {
        let currentItem = this.dataList.find((i) => i.vocabularyId === item.vocabularyId)
        this.tools.onClickYes(currentItem)
        this.countSelectNum()

        currentItem.showParaphrase = currentItem.selected === 1 ? 2 : 0
      }
    },

    onClickYes(item) {
      // 巡查官-找到当前单词在dataList中的索引，并添加到selectYesIndex中
      const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
      const yesInd = this.selectYesIndex.findIndex((i) => i == ind)
      if (yesInd == -1) {
        this.selectYesIndex.push(ind)
        this.selectYesIndex = [...new Set(this.selectYesIndex)]
      } else {
        this.selectYesIndex.splice(yesInd, 1)
      }
      // 巡查官-在selectNotIndex中查找ind，如果存在，则删除
      const notInd = this.selectNotIndex.findIndex((i) => i == ind)
      if (notInd != -1) {
        this.selectNotIndex.splice(notInd, 1)
      }

      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [item, this.selectYesIndex, this.selectNotIndex],
            fn: "onClickYesSync",
            msgType: "function",
          })
          .then(() => {
            this.onClickYesSync(item)
          })
      } catch (error) {
        // 如果出现错误，则把前面selectYesIndex的push的ind删除
        this.selectYesIndex.splice(this.selectYesIndex.length - 1, 1)
        // 如果出现错误并且selectNotIndex存在，则把ind重新添加到selectNotIndex中
        if (this.selectNotIndex.length > 0) {
          this.selectNotIndex.push(ind)
          this.selectNotIndex = [...new Set(this.selectNotIndex)]
        }
      }
    },

    onClickNotSync(item, selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectNotIndex.length; i++) {
          if (this.dataList[selectNotIndex[i]].selected != 2) {
            this.tools.onClickNot(this.dataList[selectNotIndex[i]])
          }
        }
        for (let i = 0; i < selectYesIndex.length; i++) {
          if (this.dataList[selectYesIndex[i]].selected != 1) {
            this.tools.onClickYes(this.dataList[selectYesIndex[i]])
          }
        }
        // 合并selectYesIndex和selectNotIndex，在dataList中找到索引不等于合并后的索引的单词，把selected设置为0
        const allIndex = [...selectYesIndex, ...selectNotIndex]
        for (let i = 0; i < this.dataList.length; i++) {
          if (!allIndex.includes(i)) {
            this.dataList[i].selected = 0
          }
        }
        this.countSelectNum()
      } else {
        let currentItem = this.dataList.find((i) => i.vocabularyId === item.vocabularyId)
        if (currentItem.selected != 2) {
          if (this.notNum >= 45) {
            this.alert("不能再选啦~~")
            return
          }
        }
        this.tools.onClickNot(currentItem)
        this.countSelectNum()

        currentItem.showParaphrase = currentItem.selected === 2 ? 2 : 0
      }
    },

    onClickNot(item) {
      const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
      const notInd = this.selectNotIndex.findIndex((i) => i == ind)
      if (notInd == -1) {
        this.selectNotIndex.push(ind)
        this.selectNotIndex = [...new Set(this.selectNotIndex)]
      } else {
        this.selectNotIndex.splice(notInd, 1)
      }
      // 在selectYesIndex中查找ind，如果存在，则删除
      const yesInd = this.selectYesIndex.findIndex((i) => i == ind)
      if (yesInd != -1) {
        this.selectYesIndex.splice(yesInd, 1)
      }
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [item, this.selectYesIndex, this.selectNotIndex],
            fn: "onClickNotSync",
            msgType: "function",
          })
          .then(() => {
            this.onClickNotSync(item)
          })
      } catch (error) {
        // 如果出现错误，则把前面selectNotIndex的push的ind删除
        this.selectNotIndex.splice(this.selectNotIndex.length - 1, 1)
        // 如果出现错误并且yesInd存在，则把ind重新添加到selectYesIndex中
        if (yesInd != -1) {
          this.selectYesIndex.push(ind)
          this.selectYesIndex = [...new Set(this.selectYesIndex)]
        }
      }
    },

    queryMyWordsSync(res) {
      if (res.data.success) {
        this.courseName = res.data.courseName
        this.courseId = res.data.courseId
        const page = res.data.page
        const list = page && page.list ? page.list : []
        for (let i = 0; i < list.length; i++) {
          list[i].selected = 0
          list[i].yesColor = "gainsboro"
          list[i].notColor = "gainsboro"
          list[i].showParaphrase = 0
        }
        this.dataList = list
      }
    },
    queryMyWords() {
      const appointment = this.store.getAppointment()
      let courseId = undefined
      if (appointment != null) {
        courseId = appointment.courseId
      }

      this.ajax
        .post("/vocabulary/queryMyWords", {
          studentId: this.studentId,
          courseId: courseId,
          mastery: this.mastery,
          pageNum: 1,
          pageSize: 50,
        })
        .then((res) => {
          this.queryMyWordsSync(res)
          // mqttServer
          //   .pushMsg(this.instructData, {
          //     params: [res],
          //     fn: "queryMyWordsSync",
          //     msgType: "function",
          //   })
          //   .then(() => {
          //   })


          // if (res.data.success) {
          //   this.courseName = res.data.courseName;
          //   this.courseId = res.data.courseId;
          //   for (let i = 0; i < res.data.list.length; i++) {
          //     res.data.list[i].selected = 0;
          //     res.data.list[i].yesColor = "gainsboro";
          //     res.data.list[i].notColor = "gainsboro";
          //     res.data.list[i].showParaphrase = 0;
          //     this.dataList.push(res.data.list[i]);
          //   }
          //   this.dataList = res.data.list;

          //   setTimeout(() => {
          //     sessionStorage.setItem('pageFlag', 'true')
          //   })
          // }
          //   this.courseName = res.data.courseName;
          //   this.courseId = res.data.courseId;
          //   for (let i = 0; i < res.data.list.length; i++) {
          //     res.data.list[i].selected = 0;
          //     res.data.list[i].yesColor = "gainsboro";
          //     res.data.list[i].notColor = "gainsboro";
          //     res.data.list[i].showParaphrase = 0;
          //     this.dataList.push(res.data.list[i]);
          //   }
          //   this.dataList = res.data.list;

          //   setTimeout(() => {
          //     sessionStorage.setItem('pageFlag', 'true')
          //   })
          // }
        })
    },

    onCloseSelf() {
      clearInterval(this.autoPlayTimer)
      modalController.dismiss()
    },
  },
}
</script>
<style scoped lang="less">
@import "@/assets/common.less";

.word-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.review {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 0 20%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &_mask {
    position: absolute;
    right: 0;
    top: 0;
    width: 12rem;
    z-index: 2;
  }

  &_outside {
    position: relative;
    z-index: 3;
    margin: 0 auto;
    width: 95%;
    height: 80%;
    background: #ffffff;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;

    .statistic {
      color: var(--font-grey-color);
      height: 40px;
      line-height: 40px;
      padding-left: 1rem;
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    /* 滚动条的颜色 */
    border-radius: 10px;
    /* 滚动条的角度样式 */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 鼠标悬停时的颜色 */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 滚动条轨道的颜色，可以理解为背景 */
    border-radius: 10px;
    /* 滚动条轨道的圆角 */
  }

  &_page {
    width: 100%;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }

    &.scroll-disabled {
      overflow: hidden;
      pointer-events: none;
    }

    .word-list {
      &_item {
        padding: 20px;
        border-bottom: 1px solid #eaeaea;

        .word-style {
          text-align: left;
          display: flex;
          align-items: center;
          font-size: 16px;
          word-break: break-all;
        }

        .choose-icon {
          width: 27%;
          flex-shrink: 0;
        }
      }

      .item-checked {
        border: 1px solid var(--green-bg-color);
      }

      .choose-false {
        background: linear-gradient(0deg, rgba(16, 194, 139, 0.04), rgba(16, 194, 139, 0.04));
      }

      .choose-true {
        background: linear-gradient(0deg, rgba(255, 173, 0, 0.04), rgba(255, 173, 0, 0.04));
      }

      .translate-middle {
        margin-left: 10px;
      }

      .test-icon {
        width: 24px;
      }

      .ml-3 {
        margin-left: 10px;
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8%;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);
    z-index: 4;

    &-content {
      height: 60%;
      padding: 1.5vh 3vw 0;
    }
  }
}
</style>
